function formatPublicationDate(str) {
  const date = new Date(str)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${day}/${month}/${year} - ${hours}h${minutes}`
}


function fetchGraphQLData(url, query) {
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const body = JSON.stringify({ query });

  return fetch(url, {
    method: "POST",
    headers: headers,
    body: body,
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .catch((error) => {
      throw new Error(`Error in GraphQL query: ${error.message}`);
    });
}

function renderNews(apiData, idComponent, idProcess, highlightLatest, descButton, imageSource = "") {
  const newsData = apiData.data.participatoryProcesses;
  const resultHTMLArray = [];
  const slug = apiData.data.participatoryProcesses[0].slug;
  const href = `/processes/${slug}/f/${idComponent}`;
  const defaultImage = "https://brasilparticipativo.presidencia.gov.br/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBM0lXQVE9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--8bafc7018fb30be9c9347f0bc17a9ca1fe1daa6c/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaDdCem9MWm05eWJXRjBTU0lJY0c1bkJqb0dSVlE2RkhKbGMybDZaVjkwYjE5c2FXMXBkRnNITUdrQzZBTT0iLCJleHAiOm51bGwsInB1ciI6InZhcmlhdGlvbiJ9fQ==--64bc4c4a355cc6a5184f6bcffc380675f1050437/de091323edc331be9ff2d0371d76e62414923bd9.png";

  newsData.forEach((process) => {
    process.components.forEach((component) => {
      if (component.posts) {
        component.posts.nodes.forEach((post, index) => {

          if (index === 0 && highlightLatest) {
            return;
          }

          const cleanImageSource = imageSource.replace(/\/$/, "");
          const cleanThumbnail = post.attachments[0].thumbnail.replace(/^\//, "");
          
          const imageUrl = post.attachments.length > 0
            ? `${cleanImageSource}/${cleanThumbnail}`
            : defaultImage;
          

          const date = formatPublicationDate(post.createdAt)

          post.body.translation = post.body.translation.replace(/<\/?[^>]+(>|$)/g, "");

          const newHTML = `
          <a href="${href}/posts/${post.id}" class="page-news-card">
            <img src="${imageUrl}" alt="" class="news-img"/>

            <div class="page-news-card-content">
              <span class="news-title">${post.title.translation}</span>
              <span class="news-date">${date}</span>
              <span class="main-news-subtitle">${post.body.translation}</span>
            </div>
          </a>
          `;

          resultHTMLArray.push(newHTML);
        });
      }
    });
  });

  if (resultHTMLArray.length === 0) {
    return "error";
  }

  const highlightedNew = newsData[0].components[0].posts.nodes[0];
  const cleanImageSource = imageSource.replace(/\/$/, "");
  const cleanThumbnail = highlightedNew.attachments[0].thumbnail.replace(/^\//, "");
  
  const imageUrl = highlightedNew.attachments.length > 0
    ? `${cleanImageSource}/${cleanThumbnail}`
    : defaultImage;  
    
  //remove as tags html do texto
  highlightedNew.body.translation = highlightedNew.body.translation.replace(/<\/?[^>]+(>|$)/g, "");

  // convertendo de data ISO para data de acordo com o formato do front
  // let highlightedNewDate = highlightedNew.createdAt.split("T")[0]; 
  // highlightedNewDate = highlightedNewDate.split("-").reverse().join("/");

  const highlightedNewComponent = () => {
    if (highlightLatest) {

      const highlightedDate = formatPublicationDate(highlightedNew.createdAt)

      const highlightedNewHTML = `
        <a class="main-news-card" href="${href}/posts/${highlightedNew.id}">
          <img src="${imageUrl}" alt="" class="main-news-img"/>
          <div class="main-news-content">
            <div class="main-news-header">
            <span class="main-news-title">${highlightedNew.title.translation}</span>
            <span class="news-date">${highlightedDate}</span>
            <span class="main-news-subtitle">${highlightedNew.body.translation}</span>
            </div>
          </div>
        </a>
      `;

      return highlightedNewHTML;
    }

    return "";
  }

  return `<div class="home-sections-content">

            ${highlightedNewComponent()}
            <div class="news-container">
              ${resultHTMLArray.join("\n")}
            </div>
            <div class="centered-content">
              <a href="${href}" class="br-button secondary">${descButton}</a>
            </div>
          </div>`;

}
  /**
   * Busca dados de notícias da API GraphQL e os renderiza na página.
   *
   * @param {string} apiUrl - A URL da API GraphQL. em localhost é http://localhost:3000/api
   * @param {string} href - O valor href para o link de mais notícias. ex: "http://localhost:3000/processes/teste/f/32/" 
   * @param {number} idComponent - O ID do componente. ex: 1
   * @param {number} idProcess - O ID do processo participativo. ex: 32
   * @param {string} title - O título da seção de notícias. ex: "Notícias"
   * @param {string} descButton - A descrição do botão de notícias. ex: "Mais notícias"
   * @param {boolean} highlightLatest - Se deve realçar a última notícia ou não. ex: true
   */
function manageNews(apiUrl, idComponent, idProcess, title, descButton, highlightLatest, imageSource = "") {
  const confNoticias = document.querySelector("#confnoticias");
  if (!confNoticias) {
    console.error('Elemento com id "confnoticias" não encontrado.');
    return;
  }

  const numberOfNews = highlightLatest ? 4 : 3;
  
  confNoticias.innerHTML = `<section id="news-home-section" class="home-sections-container">
                                <h2 class="home-sections-title">${title}</h2>
                                <div class="page-news-error">
                                    <div class="news-container">
                                        <span class="news-title">Carregando...</span>
                                    </div>
                                </div>
                            </section>`; 

  const query = `query {
    participatoryProcesses(filter: { id: ${idProcess} }) {
      slug
      components(filter: { id: ${idComponent} }) {
        ...on Blogs {
          posts(order: {createdAt: "DESC"}, first: ${numberOfNews}) {
            nodes {
              title {
                translation(locale: "pt-BR")
              }
              body {
                translation(locale: "pt-BR")
              }
              attachments {
                thumbnail
              }
              createdAt
              id
            }
          }
        }
      }
    }
  }`;

  fetchGraphQLData(apiUrl, query)
    .then((apiData) => renderNews(apiData, idComponent, idProcess, highlightLatest, descButton, imageSource))
    .then((renderedNewsHTML) => {
      if (renderedNewsHTML === "error" || renderedNewsHTML === "") {
        confNoticias.innerHTML = `<section id="news-home-section" class="home-sections-container br-container-lg">
                                      <h2 class="home-sections-title">${title}</h2>
                                      <div class="page-news-error">
                                          <div class="news-container">
                                              <span class="news-title">Nenhuma notícia encontrada</span>
                                          </div>
                                      </div>
                                  </section>`; 
      } else {
        let contentNoticias = `<section id="news-home-section" class="home-sections-container br-container-lg">
                                  <h2 class="home-sections-title">${title}</h2>                    
                                      ${renderedNewsHTML}                        
                               </section>`;
        confNoticias.innerHTML = contentNoticias;
      }
    })
    .catch((error) => {
      console.error("Erro:", error);
      confNoticias.innerHTML = `<section id="news-home-section" class="home-sections-container br-container-lg">
                                    <h2 class="home-sections-title">${title}</h2>
                                    <div class="page-news-error">
                                        <div class="news-container">
                                            <span>Erro ao buscar notícias.</span>
                                        </div>
                                    </div>
                                </section>`; 
    });
}

window.manageNews = {
    manageNews: manageNews,
};

export { manageNews };
